import React from 'react'
import { useTranslation } from 'react-i18next'

const FinalTabsFlight = () => {
  const { t } = useTranslation();

  return (
    <div> 
        <div class="stups-form-sec">
            <h2 className='mb-0 pb-0'>{t("finishTitle")}</h2>
            <p className='pt-0'>{t("finishMessage")}</p>
        </div>
    </div>
  )
}

export default FinalTabsFlight